export function NotFoundPage() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-2 bg-white p-8">
      <h1 className="text-2xl font-semibold text-gray-900">404</h1>
      <p className="text-gray-500">Page not found</p>
    </main>
  );
}
